module.exports = __webpack_public_path__ + "img/waccFormula.ac16906b.png";